/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponWithCode } from './BaseCouponWithCode';
import { TenantAccessPlan } from './TenantAccessPlan';
const AccessPassCouponWithCodeParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('access-plan')],
    ['plan', TenantAccessPlan],
]), BaseCouponWithCode);
export class AccessPassCouponWithCode extends BaseCouponWithCode {
    static decode(input) {
        return AccessPassCouponWithCodeParser.decode(input).map(res => new AccessPassCouponWithCode(res));
    }
    static unsafeDecode(input) {
        return AccessPassCouponWithCode.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AccessPassCouponWithCodeParser.encode(data);
    }
    static schema() {
        return AccessPassCouponWithCodeParser.schema();
    }
}
